<template>
    <!-- 资讯 -->
    <div class="page">
        <!-- 搜索头部 -->
        <panel
            ref="panel"
            :wapTitle="''"
            :appLink="'/2/8/0'"
            :spreadID="'0'"
            :showNav="false"
            :isShowNav="false"
            @gotoApp="gotoApp"
            :isApp="false"
        ></panel>
        <div class="search_top">
            <form action="/" style="display: flex;align-items: center;background: #fff;">
            <img @click="cancel" class="search_back" src="../../assets/img/Frame585_new@2x.png" alt="">
            <van-search
                v-model="value"
                show-action
                shape="round"
                background="#FFFFFF"
                placeholder="书画"
                @input="pnt"
                @search="search"
                @focus="focusValue"
                @blur="blurValue"
            >
            <template #action>
                    <div @click="search">搜索</div>
                </template>
            </van-search>
            </form>
        </div>
        <div class="wordBox"  v-if="focusFlag&&value&&wordList.length>0">
            <template  v-for="(item, index) in wordList"  >
                <div class="sourceWord" :key="index+'sourceWord'" @click.stop="jumpSearch(item)" >
                    <van-icon name="search" />
                    <span  v-html="item.source_wordShow"></span>
                </div>
            </template>
        </div>
        <!-- tab页 -->
        <div class="search_tabsmm">
            <!-- search -->
            <div class="tabItem" data-index="0" @click="scFun('35','2','1'),gotoSearch('search')">
                综合
            </div>
            <div class="tabItem" data-index="1" @click="scFun('35','2','2'),gotoSearch('paipin')">
                拍品
            </div>
            <div
                class="tabItem"
                data-index="2"
                @click="scFun('35','2','3'),gotoSearch('paiacution')"
            >
                拍卖会
            </div>
            <div class="tabItem" data-index="3" @click="scFun('35','2','4'),gotoSearch('company')">
                拍卖公司
            </div>
            <div class="tabItem" data-index="4" @click="scFun('35','2','5'),gotoSearch('market')">
                市场报告
            </div>
            <div class="tabItem active" data-index="5">资讯</div>
        </div>
        <!-- 在搜索选项有数据的时候显示的页面 -->
        <histor linkName="infor" v-if="hiss" :nunber="param.type" :water="showWater"></histor>
        <!-- 在搜索没有显示的时候 -->
        <!-- 类型一 没有图片数据 -->
        <div v-if="!hiss&&!(focusFlag&&value&&wordList.length>0)" class="infor">
            <div v-if="loadingIf">
                <div style="height: 0.75rem; background: #ffffff"></div>

                <van-list v-model="loading" :finished="finished" @load="onLoad">
                    <div
                        @click="jumpNews(item,index)"
                        class="message_container"
                        v-for="(item, index) in newsList"
                        :key="index"
                    >
                        <!-- 类型一 -->
                        <div
                            class="message_type1"
                            v-if="item && item.pic && item.pic.length == 0 || item.pic==null"
                        >
                            <div class="tp1_title">{{ item.title }}</div>
                            <div class="tp1_bottom">
                                <div class="tp1_renshu">
                                    {{ item.resource }}
                                    {{ item.published_text }}
                                </div>
                                <div class="tp1_see" v-if="item.view_num != 0">
                                    <img
                                        src="../../assets/img/icon_discover_yuedu_light.png"
                                        alt=""
                                    />
                                    {{ item.view_num }}
                                </div>
                            </div>
                        </div>
                        <!-- 类型二 -->
                        <div
                            class="message_type2"
                            v-if="item && item.pic && item.pic.length == 1"
                        >
                            <div class="tp2_box">
                                <div class="tp2_title">
                                    {{ item.title }}
                                </div>
                                <div class="tp2_img">
                                    <img :src="item.pic" alt="" />
                                </div>
                            </div>
                            <div class="tp2_bottom">
                                <div class="tp2_renshu">
                                    {{ item.resource }}
                                    {{ item.published_text }}
                                </div>
                                <div class="tp2_see" v-if="item.view_num != 0">
                                    <img
                                        src="../../assets/img/icon_discover_yuedu_light.png"
                                        alt=""
                                    />{{ item.view_num }}
                                </div>
                            </div>
                        </div>
                        <!-- 类型三 -->
                        <div
                            class="message_type3"
                            v-if="
                                item &&
                                item.pic &&
                                item.pic.length != 0 &&
                                item.pic.length != 1
                            "
                        >
                            <div class="tp3_title">{{ item.title }}</div>
                            <!-- 图片滑动 -->
                            <div class="tp3_sliding">
                                <div v-for="item in item.pic" :key="item">
                                    <img :src="item" alt="" />
                                </div>
                            </div>
                            <div class="tp3_bottom">
                                <div class="tp3_renshu">
                                    {{ item.resource }}
                                    {{ item.published_text }}
                                </div>
                                <div class="tp3_see" v-if="item.view_num != 0">
                                    <img
                                        src="../../assets/img/icon_discover_yuedu_light.png"
                                        alt=""
                                    />
                                    {{ item.view_num }}
                                </div>
                            </div>
                        </div>

                        <!-- ——————————分割线—————— -->
                    </div>
                </van-list>
                <!-- 底部 -->
                <div class="footer" v-if="noMore">
                    <div class="footer-left"></div>
                    <div class="footer-content">我是有底线的</div>
                    <div class="footer-right"></div>
                </div>
            </div>
            <emptyPage v-else></emptyPage>
        </div>
        <share :nunber="param.type"></share>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
        <watermark v-if="showWater"></watermark>
    </div>
</template>

<script>
import histor from "./component/histor.vue";
import { news,searchWord } from "@/api/auction";
import share from "./component/metaComponent.vue";
import emptyPage from "@/components/empty/emptyPage";
import panel from "@/views/preview/component/panel";
import DownLoadApp from "@/components/common/downloadApp";
import watermark from "@/components/common/watermark";
import {
    scMdFunc
} from "@/assets/js/scData";
export default {
    data() {
        return {
            showWater:false,
            waterLink:'',
            loadingIf: true,
            value: "", //搜索内容
            hiss: true,
            appLink:'/2/8/0',
            param: {
                page: 1,
                keyword: "",
            },

            newsList: [], //拍卖公司列表
            noMore: false, //我是有底线的
            loading: false,
            finished: false,
            focusFlag:false,
            wordList:[]
        };
    },
    created() {
        if(this.$route.query.from){
            this.showWater = true;
            this.waterLink = '&from='+this.$route.query.from
        }
        if (this.$route.query.searchValue) {
            this.hiss = false;
            this.value = decodeURIComponent(this.$route.query.searchValue);
            this.getnews();
        }
    },
    mounted() {
        document.querySelector('.search_tabsmm').scrollLeft = document.querySelector('.active').offsetLeft
    },
    watch: {},
    methods: {
        brightKeyword(e){
            let keyword=e;
            let val = this.value;
            keyword=keyword.trim();
            if(keyword&keyword.length>0){
                if(keyword == val){
                    return '<span>'+val+'</span>'
                }
                keyword = keyword.replaceAll("","|");
                let reg = new RegExp(keyword,"ig")
                return val.replace(reg,(match) =>{
                    return  '<span>'+match+'</span>' 
                })
            }
        },
        scFun(p='',m='',b='',dataEle) {//新单击埋点
                scMdFunc('allClick',  {
                    cur_page: p,
                    cur_moudle: p+'-'+m,
                    cur_button: p+'-'+m+'-'+b,
                    ...dataEle
                })
        },
        focusValue(){
            this.focusFlag=true;
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-1',
            })
            searchWord({
                    keyword:this.value,
                    type:5
                }).then((res) => {
                        if (res.code == 0) {
                            this.wordList = res.data.list
                            this.wordList = this.wordList.map((item) => {
                                let replaceReg = new RegExp(this.value, 'g');
                                let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                                if (item.source_word.includes(this.value)) {
                                item.source_wordShow = item.source_word.replace( replaceReg,replaceContent);
                                }else{
                                    item.source_wordShow = item.source_word
                                }
                                return item;
                            });
                        }
               })
        },
        blurValue(){
           
            let that = this;
            setTimeout(()=>{
                that.focusFlag=false;
            },500)
        },
        jumpSearch(e){
            this.value=e.source_word;
            this.gotoSearch('infor');
            // let that = this;
            // switch (e.source_type) {
            //     case 0:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 1:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 2:
            //         that.value=e.source_word;
            //         that.gotoSearch('paipin');
            //         break;
            //     case 3:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 4:
            //         that.value=e.source_word;
            //         that.gotoSearch('paiacution');
            //         break;
            //     case 6:
            //         that.value=e.source_word;
            //         that.gotoSearch('company');
            //         break;
            //     case 7:
            //         that.value=e.source_word;
            //         that.gotoSearch('market');
            //         break;
            //     case 5:
            //         that.value=e.source_word;
            //         that.gotoSearch('infor');
            //         break;
            // }
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        // 取消
        cancel() {
            let url = this.showWater ? '?from='+this.$route.query.from :'';
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-2',
            })
            // this.$router.push({ path: "/" });
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                window.location.href = "https://m-auction.artron.net/live/"+url;
            } else {
                this.$router.push({ path: "/"+url });
            }
        },
        // 搜索输入功能
        async pnt() {
            if (!this.value) {
                this.hiss = true;
                this.param.page = 1;
                this.newsList = [];
                this.$router.push({
                    name: "infor",
                    query: {
                        searchValue: "",
                        from:this.showWater ? this.$route.query.from : ''
                    },
                });
            }else{
                await searchWord({
                    keyword:this.value,
                    type:5
                }).then((res) => {
                        if (res.code == 0) {
                            this.wordList = res.data.list
                            this.wordList = this.wordList.map((item) => {
                                let replaceReg = new RegExp(this.value, 'g');
                                let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                                if (item.source_word.includes(this.value)) {
                                item.source_wordShow = item.source_word.replace( replaceReg,replaceContent);
                                }else{
                                    item.source_wordShow = item.source_word
                                }
                                return item;
                            });
                        }
               })
            }
        },
        // 点击搜索时触发
        search() {
            this.param.page = 1;
            this.newsList = [];
            this.noMore = false;
            if (this.value) {
                this.getnews();
                // this.$router.push({
                //     name: "infor",
                //     query: {
                //         searchValue: encodeURIComponent(this.value),
                //         from:this.showWater ? this.$route.query.from : ''
                //     },
                // });
                this.hiss = false;
            } else {
                this.hiss = true;
            }
        },
        // tab切换
        gotoSearch(link) {
            // this.$router.push({
            //     name: link,
            //     query: { searchValue: encodeURIComponent(this.value) },
            // });
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                this.$router.push({
                    name: link,
                    query: {
                        searchValue: encodeURIComponent(this.value),
                        searchType: "live",
                        from:this.showWater ? 'cloud' : ''
                    },
                });
            } else {
                this.$router.push({
                    name: link,
                    query: { searchValue: encodeURIComponent(this.value),
                        from:this.showWater ? this.$route.query.from : '' },
                });
            }
            this.focusFlag=false;
            //   this.$refs.tabDom.children[index].classList.add("active").
        },
        jumpNews(item,index) {
            scMdFunc('allClick', {
                cur_page: '17',
                cur_moudle: '17-4',
                cur_button: '17-4-'+(Number(index)+1),
            })
            window.location.href = item.link;
        },
        //接口
        getnews() {
            this.loadingIf = true;
            this.param.keyword = this.value;
            news(this.param).then((res) => {
                if (res.code == 0) {
                    // 埋点
                    // this.metaTitle = res.data.meta.title;
                    if (!res.data.newsList && res.data.morePage != 1) {
                        this.loading = false;
                        this.finished = true;
                    }
                    if (res.data.newsList) {
                        this.newsList = this.newsList.concat(res.data.newsList);
                        if (this.newsList.length == 0) {
                            this.loadingIf = false;
                        }
                        this.loading = false;
                        this.param.page++;
                        if (res.data.morePage == 0) {
                            this.finished = true;
                            this.noMore = true;
                        }
                    }
                    // console.log(res.data.company);
                    // 拍卖品
                }
            });
        },
        onLoad() {
            if (this.param.page >= 2) {
                this.getnews();
            }
        },
    },
    components: {
        histor,
        share,
        emptyPage,
        panel,
        DownLoadApp,
        watermark
    },
};
</script>

<style lang="scss" scoped>
// 搜索头部和tab页面
/deep/ .van-search__content {
    background-color: #f3f3f3;
    .van-icon-search::before{content:''}
    .van-field__left-icon .van-icon, .van-field__right-icon .van-icon{background:url("../../assets/img/icon_auc_search.png") no-repeat center;background-size: .7rem auto;width:.7rem;}
}
/deep/.van-search__action{padding:0 .4rem;font-size: .85rem;color:#969696;}
.search_back{
    width: 2rem;
    display: inline-block;
}
/deep/.van-search {
width: calc(100% - 2rem);
padding-left: 0;
}
.wordBox{
    position:absolute;
    top: 5rem;
    left: 0;
    background: #fff;
    width: 100%;
    z-index: 9;
    min-height: calc(100vh - 6rem);
    .sourceWord{
        width: calc(100% - 1.2rem);
        margin: 0.3rem 0.6rem;
        padding: 0.3rem 0;
        font-size: 0.8rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        i{
            font-size: 1rem;
            vertical-align: middle;
            margin-right:0.2rem;
        }
    }
}
.tabItem:last-child {
    // padding-right: 0.9rem;
    display: inline-block;
}
.search_tabsmm::-webkit-scrollbar {
    display: none;
}
.search_tabsmm {
    display: flex;
    display: -webkit-box;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    padding: 0 0.75rem;
    width: 18.75rem;
    height: 1.8rem;
    background-color: #fff;
    align-items: center;
    overflow-x: scroll;
    position: relative;
    -webkit-overflow-scrolling: touch;
}
.search_tabsmm:after{display:block;height:.05rem;width:150%;position: absolute;bottom:.025rem;background-color: #DDDEE3;content:'';left:0;}

.search_tabsmm .tabItem {
    margin-right: 0.7rem;
    line-height: 1.8rem;
    height: 1.8rem;
}

.search_tabsmm .tabItem.active {
    color: #18bd6f;
    border-bottom: 0.15rem solid #18bd6f;
    position: relative;
    z-index: 1;
}

// 底部
.message_container {
    padding-bottom: 0.75rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    background-color: #ffffff;
    .message_type1 {
        margin-bottom: 1.5rem;

        .tp1_title {
            font-size: 0.8rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #27282d;
            line-height: 1.1rem;
            //  两行显示省略号
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
        .tp1_bottom {
            margin-top: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tp1_renshu {
                font-size: 0.6rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969696;
                line-height: 0.85rem;
            }
            .tp1_see {
                font-size: 0.6rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969696;
                line-height: 0.85rem;
                display: flex;
                align-items: center;
                img {
                    margin-right: 0.1rem;
                }
            }
        }
    }

    .message_type2 {
        margin-bottom: 1.5rem;

        .tp2_box {
            display: flex;
            justify-content: space-between;
            .tp2_title {
                font-size: 0.8rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #27282d;
                line-height: 1.1rem;
                //  两行显示省略号
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                max-height: 2.2rem;
                width: 11.1rem;
            }
            .tp2_img {
                width: 5.65rem;
                height: 4.15rem;
                border-radius: 0.5rem;
                margin-left: 0.5rem;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }

        .tp2_bottom {
            margin-top: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tp2_renshu {
                font-size: 0.6rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969696;
                line-height: 0.85rem;
            }
            .tp2_see {
                font-size: 0.6rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969696;
                line-height: 0.85rem;
                display: flex;
                align-items: center;
                img {
                    margin-right: 0.1rem;
                }
            }
        }
    }

    .message_type3 {
        margin-bottom: 1.5rem;

        .tp3_title {
            font-size: 0.8rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #27282d;
            line-height: 1.1rem;
            //  两行显示省略号
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            max-height: 2.2rem;
        }
        .tp3_sliding {
            height: 4.2rem;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
            display: -webkit-box;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;
            div {
                width: 5.65rem;
                height: 100%;
                margin-right: 0.15rem;
                border-radius: .5rem;
                overflow: hidden;
                // background-color: lightcoral;
                // margin-right:10px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
        .tp3_sliding::-webkit-scrollbar {
            display: none;
        }
        .tp3_bottom {
            margin-top: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tp3_renshu {
                font-size: 0.6rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969696;
                line-height: 0.85rem;
            }
            .tp3_see {
                font-size: 0.6rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #969696;
                line-height: 0.85rem;
                display: flex;
                align-items: center;
                img {
                    margin-right: 0.1rem;
                }
            }
        }
    }

    //   分割线——————
}

/* 底线 */
.footer {
    width: 18.75rem;
    height: 4rem;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.footer .footer-content {
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #cccccc;
}
.footer .footer-left,
.footer .footer-right {
    width: 2.5rem;
    height: 0.05rem;
    background: #dddee3;
    margin: 0 0.5rem;
}
</style>